import { useRouteContext } from '@tanstack/react-router';

/**
 * Hook to get the current user's ID from the route context.
 * The userId is extracted from the JWT token and stored in the route context,
 * so this avoids unnecessary API calls. Returns undefined outside the
 * authenticated (app) route (e.g. published views).
 */
export const useCurrentUserId = (): string | undefined => {
  const routeContext = useRouteContext({ strict: false });

  return routeContext.userId;
};
